import actions from "./marketing-actions";
import getters from "./marketing-getters";
import mutations from "./marketing-mutations";
import state from "./marketing-state";
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default store;